import { TableRow } from "@mui/material";
import { CSSProperties, makeStyles } from "@mui/styles";
import { Row } from "@tanstack/react-table";
import React, { PropsWithChildren, ReactElement } from "react";
import { PaddingObject } from "../../../util/StyleUtils";
import { ColumnDefinition } from "./QATable";
import QATableCell from "./QATableCell";
import QATableSelectionBody from "./Selection/QATableSelectionBody";

const useStyles = makeStyles({
    row: {
        "&>td": {
            borderBottom: "1px solid #CCC"
        },
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.03)"
        }
    }
});

interface Props<T> {
    row: Row<T>;
    columns: ColumnDefinition<T>[];
    style?: CSSProperties;

    defaultCellPadding?: PaddingObject;

    testId?: string;
}

// See https://tanstack.com/table/v8/docs/framework/react/examples/row-dnd
function QATableRow<T>(props: PropsWithChildren<Props<T>>): ReactElement | null {
    const classes = useStyles();

    const rowContent = props.row.getVisibleCells().map(cell => {
        if (cell.column.id === "selection") {
            return (
                <QATableSelectionBody
                    key={`__${cell.column.id}|${cell.row.id}`}
                    row={props.row} />
            );
        }

        const original = props.columns
            .find(col => col.id === cell.column.id);
        if (!original) {
            return null;
        }

        return (
            <QATableCell
                testId={`${props.testId}-QATableCell-${original.id}`}
                key={original.id}
                defaultPadding={props.defaultCellPadding}
                config={original}>
                {original?.renderCell
                    && original.renderCell(cell.row.original)}
                {!original?.renderCell && String(cell.renderValue())}
            </QATableCell>
        );
    });

    return (
        <TableRow
            style={props.style}
            data-cy={`${props.testId}-TableRow`}
            className={classes.row}>

            {rowContent}

        </TableRow>
    );
}

export default QATableRow;
